module.exports = __webpack_public_path__ + "static/media/PlayAlongNow-Logo_Invert.0bcc8e1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/PlayAlongNow-Logo_Invert.svg
// module id = ./src/assets/images/preview/PlayAlongNow-Logo_Invert.svg
// module chunks = 0